import dayjs from "dayjs";

export const tickets = ({ all }) => id => {
  if (!all[id]) {
    return [];
  }

  let tickets = Object.values(all[id]).filter(v => !!v);

  tickets.sort((a, b) => {
    a = dayjs(a.createdAt)
      .toDate()
      .getTime();
    b = dayjs(b.createdAt)
      .toDate()
      .getTime();

    return b - a;
  });

  return tickets;
};

export const ticketHistoryPage = ({ history, historyPaginator }) => (
  id,
  page
) => {
  if (
    !history[id] ||
    !historyPaginator[id] ||
    !historyPaginator[id].pages[page]
  ) {
    return [];
  }

  return historyPaginator[id].pages[page].map(hid => history[id][hid]);
};

export const shareTicketRequestsPage = ({
  shareRequestsPaginator,
  shareRequests,
}) => (id, page) => {
  if (
    !shareRequestsPaginator[id] ||
    !shareRequestsPaginator[id].pages[page] ||
    !shareRequests[id]
  ) {
    return [];
  }

  return shareRequestsPaginator[id].pages[page].map(
    rid => shareRequests[id][rid]
  );
};

export const ticketHistoryNbPages = ({ historyPaginator }) => id => {
  return (historyPaginator[id] || {}).nbPages || 0;
};

export const shareTicketRequestsNbPages = ({
  shareRequestsPaginator,
}) => id => {
  return (shareRequestsPaginator[id] || {}).nbPages || 0;
};

export const shareTicketRequestsNbResults = ({
  shareRequestsPaginator,
}) => id => {
  return (shareRequestsPaginator[id] || {}).nbResults || 0;
};
